import { render } from "./TradesReview.vue?vue&type=template&id=6f726fd4&scoped=true"
import script from "./TradesReview.vue?vue&type=script&lang=js"
export * from "./TradesReview.vue?vue&type=script&lang=js"

import "./TradesReview.vue?vue&type=style&index=0&id=6f726fd4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f726fd4"]])

export default __exports__